import Typography from '@mui/material/Typography';
import Grid, { GridProps } from '@mui/material/Grid';
import React, { ReactElement } from 'react';
import { map } from 'ramda';

import * as detailsStyles from './Details.styles';
import Card from '../../../Card';

interface Data {
  title: string;
  value: string | null;
}

export interface DetailsProps {
  cardTitle: string;
  data: Data[];
  titleXs: GridProps['xs'];
  valueXs: GridProps['xs'];
}

function Details({ cardTitle, data, titleXs, valueXs }: DetailsProps): ReactElement {
  const { classes } = detailsStyles.useText();

  const items = map(
    (row) => (
      <Grid spacing={2} container key={`order-option-${row.title}`}>
        <Grid item xs={titleXs}>
          <Typography component="span" classes={classes} variant="body1">
            {row.title}
          </Typography>
        </Grid>
        <Grid item xs={valueXs}>
          {row.value && (
            <Typography component="span" classes={classes} variant="subtitle2">
              {row.value}
            </Typography>
          )}
        </Grid>
      </Grid>
    ),
    data
  );

  return <Card title={cardTitle}>{items}</Card>;
}

export default Details;
